// Open the first accordion item by default
$('.accordion-header:first').addClass('active').next('.accordion-content').slideDown('fast');

$('.accordion-header i').click(function () {
	// Find the active accordion header and content
	var activeHeader = $('.accordion-header.active');
	var activeContent = activeHeader.next('.accordion-content');

	// If the clicked header is already active, just toggle its content
	if ($(this).parent().hasClass('active')) {
		$(this).parent().toggleClass('active').next('.accordion-content').slideToggle('fast');
	} else {
		// Otherwise, close the active accordion item and open the clicked one
		activeHeader.removeClass('active');
		activeContent.slideUp('fast');

		$(this).parent().addClass('active').next('.accordion-content').slideDown('fast');
	}
});
